import React from 'react';
import Payment from './Payment';

const PaymentCancel = () => {
  return <Payment />;
};

export default PaymentCancel;